import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';
import { ConnectionApiProvider, useConnectionApi } from '../Services/ConnectionApiProvider';

function ZohoConnectionCallbackContent() {
  const { status } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { zohoConnection } = useConnectionApi();

  useEffect(() => {
    const handleZohoConnection = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const error = params.get('error');

      const connectionId = localStorage.getItem('connectionId');
      const organizationId = localStorage.getItem('connectionOrgId');

      const navigateWithAlert = (type, message) => {
        navigate(`/organizations/${organizationId}/connections/${connectionId}`, {
          state: { type, message },
        });
      };

      if (code) {
        try {
          await zohoConnection(code, connectionId);
          console.log('Zoho connected successfully');
          navigateWithAlert('success', 'Zoho connected successfully');
        } catch (err) {
          console.error('Error exchanging Zoho code:', err);
          navigateWithAlert('fail', 'Failed to connect Zoho');
        }
      } else if (error) {
        console.log('Zoho authorization canceled or failed:', error);
        navigateWithAlert('fail', 'Zoho authorization canceled');
      } else {
        console.log('No code or error received from Zoho');
        navigateWithAlert('fail', 'No code or error received from Zoho');
      }
    };

    handleZohoConnection();
  }, [zohoConnection, location.search, navigate, status.organization_id]);

  return <div>Please wait...</div>;
}

function ZohoConnectionCallbackPage() {
  return (
    <ConnectionApiProvider>
      <ZohoConnectionCallbackContent />
    </ConnectionApiProvider>
  );
}

export default ZohoConnectionCallbackPage;
